export default __webpack_public_path__ + "static/media/open-positions-pop-upfull-HD.46bc183c.jpg";